import { Typography } from "@mui/material";
import { AffirmInlineLogo } from "../common/paymentPlans/affirmLogo";
import PaymentPlansBannerWrapper from "../common/paymentPlans/paymentPlansBannerWrapper";

export default function AffirmPromotionBanner() {
  return (
    <PaymentPlansBannerWrapper>
      <Typography variant="subtitleSmall">
        We partner with <AffirmInlineLogo /> on payment plans. Buy today, pay
        later!
      </Typography>
    </PaymentPlansBannerWrapper>
  );
}
